import { useAtom, useAtomValue } from 'jotai';
import cn from 'classnames';
import { Stack } from '@pairy/pds-react';

import {
  isDisableHelpersAtom,
  zoomLevelAtom,
} from '../../../../../../store/index.atom';
import type { ZoomLevel } from '../../../../../../types/viewer';

import * as Styled from './index.styles';

interface Props {
  isMobileLandscape: boolean;
}

const MobileZoomButton = ({ isMobileLandscape }: Props) => {
  const [zoomLevel, setZoomLevel] = useAtom(zoomLevelAtom);
  const isDisableHelpers = useAtomValue(isDisableHelpersAtom);

  const handleClickZoomIn = () => {
    if (zoomLevel < 1.5) {
      setZoomLevel((prev) => (prev + 0.25) as ZoomLevel);
    }
  };

  const handleClickZoomOut = () => {
    if (zoomLevel > 0.5) {
      setZoomLevel((prev) => (prev - 0.25) as ZoomLevel);
    }
  };

  return (
    <Styled.Button
      className={cn({
        disable: isDisableHelpers,
        isLandscape: isMobileLandscape,
      })}
      variant="zinc_500"
      radius={9999}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <Stack
        direction={isMobileLandscape ? 'row' : 'column'}
        gap={16}
        justifyContent="center"
        alignItems="center"
      >
        <Styled.Icon
          icon="ph:magnifying-glass-plus"
          size={19}
          color={zoomLevel === 1.5 ? 'zinc_400' : 'black'}
          onClick={handleClickZoomIn}
        />
        <Styled.Icon
          icon="ph:magnifying-glass-minus"
          size={19}
          color={zoomLevel === 0.5 ? 'zinc_400' : 'black'}
          onClick={handleClickZoomOut}
        />
      </Stack>
    </Styled.Button>
  );
};

export default MobileZoomButton;
